import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_72: FaireProductEntity = {
  token: "starter_collection_72",
  type: "product",
  name: "Albacore Tuna with Spanish Lemon",
  brandName: "Fishwife",
  imageUrl:
    '"https://cdn.faire.com/fastly/061c0a70ce642e2c62b0c3316820c29c8366e085a17334d9e0e141fe8fffc5c0.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=1131',
  priceDollars: 12,
  msrpDollars: 24,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
